import axios from '../../config/axios';

function search(query) {
    return axios().get("/sales/customer-groups", {
        params: {
            search: query
        }
    })
}

export default {
    search
}